var exports = {
  "kL": "xe533113f--d19638--container",
  "ou": "xe533113f--d19638--tooltip-container",
  "cf": "xe533113f--d19638--tooltip-item",
  "UA": "xe533113f--d19638--content-item",
  "oe": "xe533113f--d19638--diff-content",
  "DD": "xe533113f--d19638--title",
  "qu": "xe533113f--d19638--diff-container",
  "A0": "xe533113f--d19638--diff-item",
  "Zs": "xe533113f--d19638--diff-info",
  "pS": "xe533113f--d19638--more-btn",
  "Qs": "xe533113f--d19638--content",
};

module.exports = exports;
